"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedAngularjsComponent = void 0;
const i0 = __importStar(require("@angular/core"));
const i1 = __importStar(require("@angular/common"));
const i2 = __importStar(require("../../../core/directives/upgrade-wrapper/ng1-upgraded-angular-js.directive"));
function NestedAngularjsComponent_h2_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("AngularJs component button clicked ", ctx_r0.count, " times");
} }
class NestedAngularjsComponent {
    constructor() {
        this.count = 0;
        this.exampleParam = 'Example param provided by Angular';
    }
    onCountClick(shouldCount) {
        if (shouldCount)
            this.count += 1;
    }
}
exports.NestedAngularjsComponent = NestedAngularjsComponent;
NestedAngularjsComponent.ɵfac = function NestedAngularjsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NestedAngularjsComponent)(); };
NestedAngularjsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NestedAngularjsComponent, selectors: [["nested-angularjs"]], decls: 5, vars: 2, consts: [[1, "boxContent"], [3, "outputParam", "inputParam"], [4, "ngIf"]], template: function NestedAngularjsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "h3");
        i0.ɵɵtext(2, "Angular container with upgraded Angularjs component");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "ng1-upgraded-angular-js", 1);
        i0.ɵɵlistener("outputParam", function NestedAngularjsComponent_Template_ng1_upgraded_angular_js_outputParam_3_listener($event) { return ctx.onCountClick($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, NestedAngularjsComponent_h2_4_Template, 2, 1, "h2", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("inputParam", ctx.exampleParam);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.count && ctx.count > 0);
    } }, dependencies: [i1.NgIf, i2.Ng1UpgradedAngularJsWrapper], encapsulation: 2 });
